/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState, useContext, useMemo } from "react";
import "../App.css";
// import "../ChatWidget.css";
import { useHistory, useLocation } from "react-router-dom";
// import dotpic from "../assets/Group1.svg";
import Dropdown from "react-bootstrap/Dropdown";
import { RiArrowDropDownLine } from "react-icons/ri";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import { FaAnglesLeft, FaAnglesRight } from "react-icons/fa6";
import { monthlyAlert } from "../component/ContextApi/MonthlyAlert";
import { getCompanyInfo } from "../Redux/actions/GetCompanyInfo";
import { getallRoles } from "../Redux/actions/getroles";
import { useSubbtn } from "../context/subBtn";
import bellPic from "../assets/bell.svg";
import { useRoles } from "../context/roles";
import { useSignalR } from "../context/SignalRContext";
import { useSubscription } from "../context/SubscriptionContext";
import { getallNotificationsNew } from "../Redux/actions/NotificationNew";
import ChatWidget from "../component/ChatWidget/ChatWidget";
import { useSession } from "../context/SessionContext";
import SidebarSearch from "../component/sidebar/search/SidebarSearch";
import DeleteConfirmModal from "../Common/DeleteConfirmModal";
import { storage, sessionStore } from "../Utils/storageService";
// import ThemeToggle from "../component/ThemeSwitch/ThemeToggle";
// import { useTheme } from "../context/ThemeContext";
import { renderMenuIcon } from "../ListOfPaths/MenuIcons";
import { getFirstAllowedUrl, getFirstAllowedTabUrl, isCommissionAuthorizedUser, menuForPath } from "../Utils/roleNavigation";
import { fetchAssignedProjects } from "../Redux/actions/projectselectionaction";
import NotificationDrawer from "./NotificationDrawer";
import TopModuleNav from "./TopModuleNav";

function SideButton(props) {
  return (
    <button
      onClick={() => props.onClick()}
      className={`row sideButton ${props.active ? "active" : ""}`}
      title={props.text}
    >
      {renderMenuIcon(props.icon, props.text)}
      <p className="sideText toggleButton">{props.text}</p>
    </button>
  );
}
function SideSubButton(props) {
  return (
    <div className="px-2">
      <button
        onClick={() => {
          props.onClick();
        }}
        className={props.active ? "sub_button_style_underline " : "sub_button_style "}
      >
        <span>{props.text}</span>
        <span>{props.btnComponent !== undefined ? props.btnComponent : null}</span>
      </button>
      {/* <br></br> */}
    </div>
  );
}
// A sidebar item's URL segment is guessed from its text, with exceptions where the
// two differ. This was duplicated in the subbtn-matching effect and in the SideButton
// `active` prop, and the two copies had already drifted apart — they are one function
// now so they cannot disagree again.
const menuRouteFor = (item) =>
  item.route ??
  (item.text === "Chart of Acc."
    ? "chart-of-acc"
    : item.text === "Land & Seller"
      ? "land-and-seller"
      : item.text === "Charge Heads"
        ? "charge-heads"
        : item.text === "Change Request"
          ? "change-request"
          : item.text === "Revert Vouchers"
            ? "revert-back-vouchers"
            : item.text === "Install Resch"
              ? "install-reschedule"
              : item.text === "Trans Contract"
                ? "transfer-contract"
                : item.text === "Transfer Unit"
                  ? "transfer-unit"
                  : item.text === "Work Orders"
                    ? "work-orders"
                    : item.text === "Purchase Orders"
                      ? "purchase-order"
                      : item.text === "Purchase Invoices"
                        ? "purchase-invoice"
                        : item.text === "Material Requisition"
                          ? "material-requisition"
                          : item.text === "Invoice"
                            ? "invoices"
                            : item.text === "Quotation"
                              ? "quotations"
                              : item.text === "Bill of Quantities"
                                ? "bill-of-quantities"
                                : item.text === "Rate Library"
                                  ? "rate-library"
                                  : item.text === "Contractor Bills"
                                    ? "contractor-bills"
                                    : item.text === "Measurement Book" || item.text === "M-Book"
                                      ? "measurement-book"
                                      : item.text?.toLowerCase());

// A parent counts as active when the URL belongs to any of its sub-items — a parent's
// name is often absent from its children's URLs (e.g. Registry's "Settings" owning
// /registry/charge-heads), and matching on the parent alone would leave it unhighlighted.
const normalizePath = (path) => {
  if (!path) {
    return "";
  }
  const trimmed = path.trim().toLowerCase();
  return trimmed.length > 1 && trimmed.endsWith("/") ? trimmed.slice(0, -1) : trimmed;
};

const isPathMatch = (url, target) => {
  if (!url || !target) {
    return false;
  }
  const cleanUrl = normalizePath(url);
  const cleanTarget = normalizePath(target);

  // If target starts with '/', match against full path segment boundary
  if (cleanTarget.startsWith("/")) {
    return (
      cleanUrl === cleanTarget ||
      cleanUrl.startsWith(`${cleanTarget}/`) ||
      cleanUrl.startsWith(`${cleanTarget}?`)
    );
  }

  // If target is a relative segment like "receipt-entry" or "coa/heading"
  const targetWithSlash = `/${cleanTarget}`;
  return (
    cleanUrl === cleanTarget ||
    cleanUrl.endsWith(targetWithSlash) ||
    cleanUrl.includes(`${targetWithSlash}/`) ||
    cleanUrl.includes(`${targetWithSlash}?`)
  );
};

const isSubbtnActive = (btn, currentUrl) => {
  if (!btn || !currentUrl) {
    return false;
  }

  // 1. If button has subTab array (e.g. vouchers), check if any subTab matches currentUrl
  if (Array.isArray(btn.subTab) && btn.subTab.length > 0) {
    const hasActiveTab = btn.subTab.some(
      (tab) => isPathMatch(currentUrl, tab.url) || isPathMatch(currentUrl, tab.route),
    );
    if (hasActiveTab) {
      return true;
    }
  }

  // 2. Check btn.url first when available (canonical absolute path)
  if (btn.url && isPathMatch(currentUrl, btn.url)) {
    return true;
  }

  // 3. Fall back to relative btn.route if specified
  if (btn.route && isPathMatch(currentUrl, btn.route)) {
    return true;
  }

  return false;
};

const isMenuItemActive = (item, currentUrl) => {
  const route = menuRouteFor(item);
  if (route && isPathMatch(currentUrl, route)) {
    return true;
  }
  return !!item.subbtn?.some((sub) => isSubbtnActive(sub, currentUrl));
};

const Layout = (props) => {
  const { arr, children } = props;
  const location = useLocation();
  const currentUrl = location.pathname;

  const subbuttonRef = useRef(null);

  const history = useHistory();
  const { subbtn, setSubbtn, setTab, tab, setScrollPosition, scrollPosition } = useSubbtn();
  const [tabcount, setTabCount] = useState("");
  const { roles, setRoles } = useRoles();
  const { session } = useSession();
  // const { toggleTheme, isTheme2 } = useTheme();
  const IsAiEnabled = session?.IsAiEnabled;
  const companyInfo = useSelector((state) => state.getCompany);
  const rolesdata = useSelector((state) => state.GetAllRole);
  const assignedProjects = useSelector((state) => state.assignedProjects?.assignedProjects);
  const dispatch = useDispatch();

  const selectedAssignedProject = Array.isArray(assignedProjects)
    ? assignedProjects.find((project) => String(project.ProjectId) === String(session?.ProjectId))
    : null;
  const selectedProjectOwner =
    selectedAssignedProject?.ProjectOwner || session?.ProjectOwner || storage.getProjectOwner();
  const isPersonalProject = `${selectedProjectOwner || ""}`.trim().toUpperCase() === "PERSONAL";

  useEffect(() => {
    if (!Array.isArray(assignedProjects) || assignedProjects.length === 0) {
      dispatch(fetchAssignedProjects());
    }
  }, [dispatch, assignedProjects]);

  useEffect(() => {
    if (!storage.getToken()) {
      storage.clearAll();
      history.push({ pathname: "/" });
    }
  }, [history]);
  const [reload, setreload] = useState(true);
  const [toggle, setToggle] = useState(window.innerWidth > 1440);

  const { changeState } = useContext(monthlyAlert);
  const notifications = useSelector((state) => state.getnotificationsNew || {});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { stopConnection } = useSignalR();
  const { setSubscriptionError } = useSubscription();

  const [showAlert, setshowAlert] = useState(false);
  const [matchedTabsState, setMatchedTabsState] = useState({});
  const [matchedMenuState, setMatchedMenuState] = useState({});

  const userRolesList = rolesdata?.data?.UserRoles || roles?.data?.UserRoles || [];
  const currentUserEmail = rolesdata?.data?.UserName || roles?.data?.UserName || "";
  const canAccessCommissions = isCommissionAuthorizedUser(currentUserEmail);

  const visibleSubButtons = useMemo(() => {
    if (!Array.isArray(subbtn?.subbtn)) {
      return [];
    }
    return subbtn.subbtn.filter((btn) => {
      if (!btn || !btn.text) {
        return false;
      }
      if (btn.requiresProject && !session?.ProjectId) {
        return false;
      }
      if (
        btn.text === "Sales Recovery" &&
        `${session?.ProjectName || ""}`.trim().toUpperCase() === "HEAD OFFICE"
      ) {
        return false;
      }
      if (btn.text === "Tax" && `${storage.getCOA() || ""}`.trim().toLowerCase() === "yes") {
        return false;
      }
      if (btn.url?.startsWith("/commission")) {
        return canAccessCommissions;
      }
      return userRolesList.includes(btn.rolename);
    });
  }, [subbtn, session?.ProjectId, session?.ProjectName, userRolesList, canAccessCommissions]);

  const [dash, setDash] = useState("");
  const [isAiAgentVisible, setIsAiAgentVisible] = useState(() => {
    const storedVisibility = storage.getIsAiAgentVisible();
    return storedVisibility !== null ? storedVisibility : true;
  });
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  useEffect(() => {
    storage.setIsAiAgentVisible(isAiAgentVisible);
  }, [isAiAgentVisible]);

  useEffect(() => {
    if (sessionStore.getIsPaid() === "false") {
      changeState(true);
      setshowAlert(true);
    } else {
      changeState(false);
      setshowAlert(false);
    }
  }, []);

  useEffect(() => {
    if (rolesdata?.data?.UserRoles) {
      setRoles(rolesdata);
    }
  }, [rolesdata]);
  useEffect(() => {
    if (subbtn?.subbtn) {
      const matchingMenuItem = subbtn?.subbtn?.find((item) => isSubbtnActive(item, currentUrl));
      if (matchingMenuItem && matchingMenuItem?.subTab) {
        setTab(matchingMenuItem?.subTab);
        setTabCount(matchingMenuItem?.subTab);
      } else {
        setTab(null);
      }
    } else {
      setTab(null);
    }
  }, [subbtn, currentUrl]);

  useEffect(() => {
    dispatch(getallRoles());
  }, [dispatch]);

  useEffect(() => {
    if (!roles) {
      dispatch(getallRoles());
    }
    // if (!roles) return;

    const tempMatchedTabsState = {};
    if (Array.isArray(tabcount)) {
      tabcount.forEach((tab) => {
        const isAllowed = tab.url?.startsWith("/commission")
          ? canAccessCommissions
          : roles?.data?.UserRoles?.includes(tab.rolename);
        if (isAllowed) {
          tempMatchedTabsState[tab.name] = true;
        }
      });
    }
    setMatchedTabsState(tempMatchedTabsState);
  }, [roles, dispatch, tabcount, canAccessCommissions]);
  const length = Object.keys(matchedTabsState).length;

  useEffect(() => {
    const tempMatchedMenuState = {};
    if (Array.isArray(arr)) {
      arr.forEach((tab) => {
        // Vouchers and Investment are not shown at all in Main Chart of Account mode (no
        // specific project selected) — neither section's backend endpoints are scoped to
        // work correctly against an all-projects aggregate yet. Reports is NOT blanket-hidden
        // here anymore — individual unsafe reports are hidden one-by-one via the
        // `requiresProject` flag on each sub-item (see ListOfPaths.jsx + the sub-tab
        // filtering effect above), so reports that have been fixed for Main Chart of Account
        // still show.
        if ((tab.text === "Vouchers" || tab.text === "Investment") && !session?.ProjectId) {
          return;
        }
        // Analytics menu item now gated by role again (was TEMP'd open):
        // tab.rolename === "ERP-Accounts_Analytics" ||
        const isAllowed = tab.url?.startsWith("/commission")
          ? canAccessCommissions
          : roles?.data?.UserRoles?.includes(tab.rolename);
        if (isAllowed) {
          tempMatchedMenuState[tab.text] = true;
        }
      });
    }
    setMatchedMenuState(tempMatchedMenuState);
  }, [roles, arr, session?.ProjectId, canAccessCommissions]);

  useEffect(() => {
    dispatch(getallNotificationsNew());
  }, [dispatch]);

  useEffect(() => {
    if (companyInfo?.data?.length === 0 && companyInfo.loading === true) {
      dispatch(getCompanyInfo());
    }
  }, [companyInfo, dispatch]);
  const toggleClose = () => {
    setToggle(!toggle);
  };

  const handleDraw = () => {
    openDrawer();
  };

  function openDrawer() {
    setDrawerOpen(true);
  }

  function closeDrawer() {
    setDrawerOpen(false);
  }
  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = async () => {
    await stopConnection();
    storage.clearAll();
    setSubscriptionError(null);

    history.push({
      pathname: "/",
    });
  };

  useEffect(() => {
    if (arr) {
      // Without the sub-item fallback in isMenuItemActive, this effect clears the
      // sub-menu the click just opened, and it takes two clicks to stick.
      const matchingMenuItem = arr.find((item) => isMenuItemActive(item, currentUrl));

      setDash(matchingMenuItem?.text);
      setSubbtn(matchingMenuItem);
    }
  }, [currentUrl]);
  // const handleChange = () => {
  //     history.push("/settings/change-request");
  // };
  // const handleWhatsApp = () => {
  //     history.push("/settings/whatsapp/instances");
  // };
  useEffect(() => {
    if (subbuttonRef.current) {
      subbuttonRef.current.scrollTop = scrollPosition;
    }
  }, [reload, scrollPosition, subbuttonRef.current]);

  // The top bar's modules, in display order. TopModuleNav moves whichever do not fit
  // the bar's width into its "More" menu.
  const userRoles = roles?.data?.UserRoles || [];
  // Works and Procurement use the existing role names until module-specific
  // permissions are introduced.
  const canAccessWorks = [
    "Store Dashboard_View",
    "Store Work Orders_View",
    "Store Work Orders_Create",
    "Store Contractors_View",
    "Store Contractors_Create",
  ].some((role) => userRoles.includes(role));
  const canAccessProcurement = [
    "Store Dashboard_View",
    "Store Purchase Orders_View",
    "Store Purchase Orders_Create",
    "Store Vendors_View",
    "Store Vendors_Create",
  ].some((role) => userRoles.includes(role));
  const clearSubbtn = () => setSubbtn("");

  const getMenuTargetUrl = (menuItem) => {
    if (menuItem?.text === "Tax" && `${storage.getCOA() || ""}`.trim().toLowerCase() === "yes") {
      return (
        menuItem.subbtn?.find((item) => item.text === "Tax Payable")?.url ||
        menuItem.subbtn?.find((item) => item.text !== "Tax")?.url
      );
    }

    return (
      getFirstAllowedUrl([menuItem], userRolesList, {
        hasProject: !!session?.ProjectId,
      }, currentUserEmail) || menuItem.subbtn?.[0]?.url
    );
  };
  const topModules = [
    {
      key: "accounts",
      label: "Accounts",
      to: "/projectSelection",
      visible: userRoles.includes("Accounts"),
      active: isPathMatch(currentUrl, "/account"),
    },
    {
      key: "sales",
      label: "Sales",
      to: { pathname: "/projectSelection", state: { module: "Contract" } },
      visible:
        userRoles.includes("Accounts_Contract") ||
        userRoles.includes("Contract") ||
        userRoles.includes("ERP-Contract_Dashboard"),
      active: isPathMatch(currentUrl, "/contract") || isPathMatch(currentUrl, "/sales"),
      onClick: clearSubbtn,
    },
    {
      key: "inventory",
      label: "Inventory",
      to: "/inventory/dashboard",
      visible: userRoles.includes("ERP Inventory"),
      active: isPathMatch(currentUrl, "/inventory"),
      onClick: clearSubbtn,
    },
    {
      key: "commissions",
      label: "Commissions",
      to: "/commission/dashboard",
      visible: canAccessCommissions,
      active: isPathMatch(currentUrl, "/commission"),
      onClick: clearSubbtn,
    },
    {
      key: "property",
      label: "Estates",
      to: { pathname: "/projectSelection", state: { module: "Property" } },
      visible: userRoles.includes("Property Management"),
      active:
        isPathMatch(currentUrl, "/property") || isPathMatch(currentUrl, "/property-management"),
      onClick: clearSubbtn,
    },
    // Registry has its own fixed project, hidden from project selection, so it links
    // straight to the module rather than via /projectSelection.
    {
      key: "registry",
      label: "Registry",
      to: "/registry/dashboard",
      visible: userRoles.includes("Registry"),
      active: isPathMatch(currentUrl, "/registry"),
      onClick: clearSubbtn,
    },
    {
      key: "works",
      label: "Works",
      to: "/works/dashboard",
      visible: canAccessWorks,
      active: isPathMatch(currentUrl, "/works") || isPathMatch(currentUrl, "/store/contractors"),
      onClick: clearSubbtn,
    },
    {
      key: "client-work",
      label: "Client Work",
      to: "/client-work/dashboard",
      visible: canAccessWorks,
      active: isPathMatch(currentUrl, "/client-work"),
      onClick: clearSubbtn,
    },
    {
      key: "procurement",
      label: "Procurement",
      to: "/procurement/dashboard",
      visible: canAccessProcurement,
      active: isPathMatch(currentUrl, "/procurement") || isPathMatch(currentUrl, "/store/vendors"),
      onClick: clearSubbtn,
    },
    // Store no longer forces project selection first — it's business-wide; project
    // pickers live inline on the screens that need one (PO/WO/Gate Pass). The old
    // entry point was /projectSelection with state { module: "Operations" }.
    {
      key: "store",
      label: "Store",
      to: "/store/dashboard",
      visible: userRoles.includes("Store") || userRoles.includes("Store Dashboard_View"),
      active:
        isPathMatch(currentUrl, "/store") &&
        !isPathMatch(currentUrl, "/store/contractors") &&
        !isPathMatch(currentUrl, "/store/vendors"),
      onClick: clearSubbtn,
    },
    {
      key: "hr",
      label: "HR",
      to: "/hr/dashboard",
      visible: userRoles.includes("Human Resource"),
      active: isPathMatch(currentUrl, "/hr"),
      onClick: clearSubbtn,
    },
    // CRM (/crm/dashboard?LoginIdNew=…&tokenNew=…, role "CRM") and Assets
    // (/asset/dashboard, role "Assets") were already switched off here.
  ].filter((m) => m.visible);

  const selectedProjectName = storage.getProjectName();
  const showProjectName =
    Boolean(
      selectedProjectName && selectedProjectName !== "null" && selectedProjectName !== "undefined",
    ) &&
    (isPathMatch(currentUrl, "/account") ||
      isPathMatch(currentUrl, "/contract") ||
      isPathMatch(currentUrl, "/sales") ||
      isPathMatch(currentUrl, "/property") ||
      isPathMatch(currentUrl, "/property-management"));

  return (
    <>
      {/* top name bar */}
      <ToastContainer theme={"dark"} autoClose={2000} />
      {roles?.data?.UserRoles?.includes("Settings_AI Agent") && IsAiEnabled && (
        <ChatWidget isVisible={isAiAgentVisible} onCloseAvatar={() => setIsAiAgentVisible(false)} />
      )}
      <DeleteConfirmModal
        open={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={confirmLogout}
        heading="Confirm Logout"
        message="Are you sure you want to logout?"
        actionText="Logout"
        actionVariant="cancel"
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          height: "100vh",
          overflow: "hidden",
        }}
      >
        <div
          className={`col-auto m-0 p-0 sidebuttonsheight main_btn_style ${!toggle ? "sidebar-collapsed" : ""}`}
          id="tog"
          style={{
            width: toggle ? "var(--sidebar-width)" : "var(--sidebar-collapsed-width)",
            height: "100vh",
            overflowX: "visible",
            overflowY: "auto",
            transition: "width 0.3s ease",
          }}
        >
          <div
            style={{
              textAlign: "right",
              marginRight: "20px",
              marginLeft: toggle ? "0" : "25px",
            }}
          >
            {toggle ? (
              <FaAnglesLeft
                onClick={() => {
                  toggleClose();
                }}
                style={{
                  fontSize: "1.25rem",
                  marginTop: "30px",
                  color: "var(--sidebar-toggle-arrow, #056363)",
                  cursor: "pointer",
                }}
              />
            ) : (
              <FaAnglesRight
                onClick={() => {
                  toggleClose();
                }}
                style={{
                  fontSize: "1.25rem",
                  marginTop: "30px",
                  color: "var(--sidebar-toggle-arrow, #056363)",
                  cursor: "pointer",
                }}
              />
            )}
          </div>
          {toggle && <SidebarSearch arr={arr} currentUrl={currentUrl} history={history} />}
          {/* <div className="line_styling">
            <hr></hr>
          </div> */}
          <div className=" m_top_custom  ">
            {/* buttons map function */}

            {arr[0]?.rolename === "Roles" ||
            arr[0]?.rolename === "Users" ||
            arr[0]?.rolename === "Change Request" ||
            arr[0]?.rolename === "Revert Back Vouchers"
              ? arr.map((btn, index) => (
                  <SideButton
                    key={index}
                    text={btn.text}
                    icon={btn.icon}
                    onClick={() => {
                      if (showAlert) {
                        changeState(true);
                      }

                      setSubbtn(btn);

                      if (!btn.subbtn) {
                        history.push(btn.url);
                      } else {
                        const target = getMenuTargetUrl(btn);
                        if (target) {
                          history.push(target);
                        }
                      }
                    }}
                    active={
                      btn.rolename === "Change Request"
                        ? !!currentUrl.toLowerCase().includes("change-request")
                        : btn.rolename === "Revert Back Vouchers"
                          ? !!currentUrl.toLowerCase().includes("revert-back-vouchers")
                          : !!currentUrl.toLowerCase().includes(btn.text?.toLowerCase())
                    }
                  />
                ))
              : arr
                  .filter((SingleTab) => matchedMenuState[SingleTab.text])
                  .map(
                    (btn, index) => (
                      <SideButton
                        key={index}
                        text={btn.text}
                        icon={btn.icon}
                        onClick={() => {
                          if (showAlert) {
                            changeState(true);
                          }

                          setSubbtn(btn);

                          if (!btn.subbtn) {
                            history.push(btn.url);
                          } else {
                            const target = getMenuTargetUrl(btn);
                            if (target) {
                              history.push(target);
                            }
                          }
                        }}
                        active={isMenuItemActive(btn, currentUrl)}
                      />
                    ),
                    // ) : null
                  )}
          </div>
        </div>

        {/* <div className="col" style={{ overflowX: "auto" }}> */}
        <div
          className="col"
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            overflow: "hidden",
          }}
        >
          {/* top nav bar start */}

          <div className="row pt-1">
            <div
              className="col-auto d-flex flex-column justify-content-center py-1 top-brand-container"
              style={{
                width: "190px",
                maxWidth: "190px",
                minWidth: "0",
                overflow: "hidden",
              }}
            >
              <span
                className="name_heading top-company-name green_text"
                title={rolesdata?.data?.FullName}
                style={{
                  display: "block",
                  width: "100%",
                  maxWidth: "100%",
                  minWidth: "0",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {rolesdata?.data?.FullName}
              </span>
              {showProjectName && (
                <span
                  className="top-project-name-sub"
                  title={selectedProjectName}
                  style={{
                    display: "block",
                    width: "100%",
                    maxWidth: "100%",
                    minWidth: "0",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {selectedProjectName}
                </span>
              )}
            </div>
            <div className="col py-1">
              <div className="row pl-md-2 pl-lg-3 align-items-center">
                <TopModuleNav className="col nav-space" modules={topModules} />
                <div className="col-auto">
                  <span className="right_nav align-items-center">
                    {/* <span className="mr-2 d-none d-sm-inline-flex align-items-center">
                      <ThemeToggle />
                    </span> */}
                    {!rolesdata?.data?.IsCustomer && (
                      <span className=" mt-1 mr-1">
                        <Dropdown onClick={handleDraw} id="openDrawerBtn">
                          <Dropdown.Toggle
                            variant="success"
                            id="dropdown-basic"
                            className="accountBtn p-0"
                          >
                            <img src={bellPic} alt="bell" className="ml-3 Icontaxbell" />
                            <span className="badge badge-pill badge-primary py-1">
                              {notifications?.data?.pagination?.unreadCount || 0}
                            </span>
                          </Dropdown.Toggle>
                        </Dropdown>
                      </span>
                    )}
                    <span className=" ml-2">
                      <img
                        className="imageCircle"
                        src={
                          rolesdata?.data?.IsCustomer
                            ? rolesdata?.data?.CustomerImageLink
                            : companyInfo?.data?.Logo || "/GravityLogo.png"
                        }
                        alt="logo"
                      />
                    </span>
                    <span className="logout-box">
                      <Dropdown className="accountBtn  drop_icon_style">
                        <Dropdown.Toggle
                          variant="success"
                          id="dropdown-basic"
                          className="accountBtn p-0"
                        >
                          <RiArrowDropDownLine className=" drop_icon_style" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={handleLogout} className="custom-dropdown-item">
                            Logout
                          </Dropdown.Item>

                          {/* <Dropdown.Item onClick={toggleTheme} className="custom-dropdown-item">
                            {isTheme2 ? "Switch to Theme 1" : "Switch to Theme 2"}
                          </Dropdown.Item> */}

                          {rolesdata?.data?.UserRoles?.includes(
                            "ERP-Settings",
                            // "Settings_Revert Back Vouchers"
                          ) && (
                            <Dropdown.Item
                              onClick={() => {
                                const target =
                                  getFirstAllowedUrl(
                                    menuForPath("/settings"),
                                    rolesdata?.data?.UserRoles,
                                  ) || "/settings/users";
                                history.push({
                                  pathname: target,
                                });
                              }}
                              className="custom-dropdown-item"
                            >
                              Settings
                            </Dropdown.Item>
                          )}
                          {rolesdata?.data?.UserRoles?.includes("Settings_AI Agent") &&
                            IsAiEnabled && (
                              <Dropdown.Item
                                onClick={() => setIsAiAgentVisible(true)}
                                className="custom-dropdown-item"
                              >
                                AI Agent
                              </Dropdown.Item>
                            )}
                          {/* {rolesdata?.data?.UserRoles?.includes(
                                                        "Settings_Revert Back Vouchers"
                                                    ) && (
                                                        <Dropdown.Item
                                                            onClick={() => {
                                                                history.push({
                                                                    pathname:
                                                                        "/settings/revert-back-vouchers",
                                                                });
                                                            }}>
                                                            {"  "}
                                                            Revert Back Vouchers
                                                        </Dropdown.Item>
                                                    )}
                                                    {rolesdata?.data?.UserRoles?.includes(
                                                        "Settings_Roles"
                                                    ) && (
                                                        <Dropdown.Item
                                                            onClick={() => {
                                                                history.push({
                                                                    pathname:
                                                                        "/settings/roles",
                                                                });
                                                            }}>
                                                            {"  "}
                                                            Roles
                                                        </Dropdown.Item>
                                                    )}
                                                    {rolesdata?.data?.UserRoles?.includes(
                                                        "Settings_Users"
                                                    ) && (
                                                        <Dropdown.Item
                                                            onClick={() => {
                                                                history.push("/settings/users");
                                                            }}>
                                                            {"  "}
                                                            Users
                                                        </Dropdown.Item>
                                                    )}
                                                    {rolesdata?.data?.UserRoles?.includes(
                                                        "Settings_Change Request"
                                                    ) && (
                                                        <Dropdown.Item
                                                            onClick={handleChange}>
                                                            Change Request
                                                        </Dropdown.Item>
                                                    )}{" "}
                                                    {rolesdata?.data?.UserRoles?.includes(
                                                        "Settings_WhatsApp"
                                                    ) && (
                                                        <Dropdown.Item
                                                            onClick={handleWhatsApp}>
                                                            WhatsApp Settings
                                                        </Dropdown.Item>
                                                    )} */}
                          {/* <Dropdown.Item
                                                        onClick={() => {
                                                        setview(<ChangeInReqMain />);
                                                        setChosen1("");
                                                        }}
                                                    >
                                                        {"  "}
                                                        Change Request 2
                                                    </Dropdown.Item> */}
                        </Dropdown.Menu>
                      </Dropdown>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row"> */}
          <div
            className="row"
            style={{
              flex: 1,
              minHeight: 0, // 🔥 CRITICAL
            }}
          >
            {/* <div className="col-auto subbuttonheight pl-2 pr-2">
              {subbtn?.subbtn !== undefined && subbtn.subbtn !== null
                ? subbtn.subbtn.map((btn, index) =>
                    btn !== null && btn.text !== undefined ? (
                      (rolesdata?.data?.UserRoles?.includes(btn.rolename)
                         ||
                      storage.getDesignation() === "Admin" ? (
                        <SideSubButton
                          key={index}
                          text={btn.text}
                          btnComponent={btn.btnComponent}
                          onClick={() => {
                            if (showAlert) {
                              changeState(true);
                            }
                            setsubbutton(btn.text);
                            if (btn.subTab) {
                              setTab(btn.subTab);
                              history.push(btn.subTab[0].url);
                            } else {
                              setTab([]);
                              history.push(btn.url);
                            }
                            setreload(!reload);
                          }}
                          active={
                            currentUrl.includes(btn.route ? btn.route : btn.url)
                              ? true
                              : false
                          }
                        />
                      ) : null
                    ) : null
                  )
                : null}
            </div> */}
            {visibleSubButtons.length > 1 && (
              <div className="col-auto subbuttonheight m-0 p-0" id="sideBtn" ref={subbuttonRef}>
                {visibleSubButtons.map((btn, index) => (
                  <SideSubButton
                    key={index}
                    text={btn.text}
                    btnComponent={btn.btnComponent}
                    onClick={() => {
                      if (showAlert) {
                        changeState(true);
                      }

                      setScrollPosition(subbuttonRef?.current?.scrollTop);
                      if (btn.subTab) {
                        setTab(btn.subTab);
                        const target =
                          getFirstAllowedTabUrl(btn.subTab, userRolesList, {
                            hasProject: !!session?.ProjectId,
                          }, currentUserEmail) || btn.subTab[0]?.url;
                        if (target) {
                          history.push(target);
                        }
                      } else {
                        setTab([]);
                        history.push(btn.url);
                      }
                      setreload(!reload);
                    }}
                    active={isSubbtnActive(btn, currentUrl)}
                  />
                ))}
              </div>
            )}

            {/* <div className="col overflow-auto viewcompmg"> */}
            <div
              className="col viewcompmg"
              style={{
                overflowY: "auto",
                overflowX: "hidden",
                height: "100%",
                minHeight: 0,
              }}
            >
              {/* component rendering */}
              <div className="row  ">
                <div
                  // className="dash_background col-md-12 p-0"
                  className={
                    dash === "Dashboard" ||
                    dash === "Analytics" ||
                    currentUrl.includes("affiliate-leaderboard") ||
                    currentUrl.includes("affiliate-commission")
                      ? "dash_background_dashboard col-md-12 p-0"
                      : "dash_background col-md-12 p-0"
                  }
                >
                  <div className="row ">
                    <div className="col-md-12 tab-row pl-pr-0">
                      {Array.isArray(tab) &&
                        tab
                          .filter((SingleTab) => matchedTabsState[SingleTab.name])
                          .filter(
                            (SingleTab) =>
                              !(SingleTab.name === "Deal Sold Receipt" && !isPersonalProject),
                          )
                          .filter(
                            (SingleTab) =>
                              !(SingleTab.name === "Deal Payment" && isPersonalProject),
                          )
                          .filter(
                            (SingleTab) =>
                              !(SingleTab.name === "Developer Payment" && isPersonalProject),
                          )
                          .map((SingleTab, index) => (
                            <button
                              key={index}
                              title={SingleTab?.name || SingleTab?.info}
                              className={
                                currentUrl.includes(SingleTab?.route)
                                  ? length < 3
                                    ? "comp_btns_selected2 ml-1"
                                    : "comp_btns_selected ml-1"
                                  : length < 3
                                    ? "comp_btns2 ml-1"
                                    : "comp_btns ml-1"
                              }
                              onClick={() => {
                                history.push(SingleTab.url);
                              }}
                            >
                              <span
                                className="comp_btns_text"
                                style={
                                  // SingleTab?.name === "General Receipt"
                                  //   ? {}
                                  //   : localStorage.getItem("ProjectName") !==
                                  //     "HEAD OFFICE"
                                  //   ? {
                                  //       textDecorationLine: "none",
                                  //     }
                                  // :
                                  {
                                    // textDecorationLine: "line-through",
                                    // textDecorationStyle: "solid",
                                    textDecorationLine: "none",
                                  }
                                }
                              >
                                <div>{SingleTab?.info}</div>
                              </span>
                            </button>
                          ))}
                    </div>

                    <div
                      className="col-md-12 m-0 px-3 pb-2"
                      style={{ minWidth: "50vw", height: "100%" }}
                    >
                      {children}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <NotificationDrawer onClose={closeDrawer} isOpen={drawerOpen} dispatch={dispatch} />

      <div className="drawer-backdrop"></div>

      {/* {rolesdata?.loading === true ? <FullScreenLoader /> : <></>} */}
    </>
  );
};
export default Layout;
// Layout.propTypes = {
//   activePage: PropTypes.any.isRequired,
// }
